export enum ResponseStatus {
  Canceled = 'canceled',
  UnsupportedCollection = 'Unsupported collection',
}
